<template lang="html">
    <div>
        <h2 class="text-center py-3 bold" v-html="info.title"></h2>
        <div v-html="info.message"></div>
        <div class="mt-5">
            <button class="btn action wide w-100" @click="clickedOk">OK</button>
            <!-- <button class="btn action wide w-100" @click="clickedCancel">Cancel</button> -->
        </div>
    </div>
</template>

<script>
export default {
    props:{
        info: {
            type: Object,
        }
    },
    methods:{
        clickedOk: function () {
            this.$emit('clickedOk')
        },
        clickedCancel: function () {
            this.$emit('clickedCancel')
        },
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// default.vue?497573f0